module.exports = __webpack_public_path__ + "img/142.d96108d5.jpg";